import "./index.css";

function ProfileHint(props) {
	return (
		<h3 className="profile-hint poppins-font">
			Selecione abaixo seu estado de vacinação
		</h3>
	);
}

export default ProfileHint;